export default __webpack_public_path__ + "static/media/gh.2bbc2039.svg";